module.exports = __webpack_public_path__ + "img/team99.3b86cebb.jpg";